import MarginOptions from './MarginOptions'
import Input from './Input'
import SVGInput from './SVGInput'
import RichTextInput from './RichTextInput'
import {
  ChangeEvent,
  DynamicContentType,
  LucideIconName,
  ServiceCardData,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<ServiceCardData>
  setData: (e: ChangeEvent<LucideIconName | string>) => void
}

const ServiceCardEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  return (
    <>
      <SVGInput name='icon' value={content.data.icon} onChange={setData} />
      <Input
        light
        label={tr(TrKey.serviceCardEditorHeaderLabel)}
        placeholder={tr(TrKey.serviceCardEditorHeaderPlaceholder)}
        type='header'
        name='header'
        id='header'
        value={content.data.header}
        onChange={setData}
      />
      <RichTextInput value={content.data.html} name='html' onChange={setData} />
      <Input
        light
        label={tr(TrKey.serviceCardEditorButtonTextLabel)}
        placeholder={tr(TrKey.serviceCardEditorButtonTextPlaceholder)}
        type='ctaText'
        name='ctaText'
        id='ctaText'
        value={content.data.ctaText}
        onChange={setData}
      />
      <Input
        light
        label={tr(TrKey.serviceCardEditorButtonLinkLabel)}
        placeholder={tr(TrKey.serviceCardEditorButtonLinkPlaceholder)}
        type='ctaLink'
        name='ctaLink'
        id='ctaLink'
        value={content.data.ctaLink}
        onChange={setData}
      />
      <MarginOptions content={content} setData={setData} topLine />
    </>
  )
}

export default ServiceCardEditor
